import './App.css';
import Content from './components/Content';
import Navbar from './components/Navbar';
import About from './components/About';
import Experience from './components/Experience';
import Project from './components/Project';
import Contact from './components/Contact';
import Achievement from './components/Achievement';
import Footer from './components/Footer';

function App() {
  return (
    <>
    <Navbar/>
    <Content/>
    <About/>
    <Experience/>
    <Project/>
    <Achievement/>
    <Contact/>
    <Footer/>
    </>
  );
}

export default App;
